import LookupDataService from "../services/LookupDataService";
import SmeService from "../services/SmeService";
import CountryProvinceService from "../services/CountryProvinceService";
import CountryService from "../services/CountryService";
import ServiceLookupData from "../services/LookupDataService";
import ServiceLookupType from "../services/LookupTypeService";
import { validatorHelper, responseHelper, history } from "../helpers";
import Keys from "../json/ResourceStartup.json";
import * as LanguageHelper from "../helpers/language.helper";
import { logHelper } from "../helpers/log.helper";
import * as AuthenticationHelper from "../helpers/authentication.helper";
// responseHelper.validateResponses(responses);
//Validate Response validira responses dali ima nekakvi greski
//responses = [] --niza
//Iterira niz nea i ako e TRUE togas gi vraka samite responses[] koj sto bile prateni za inspekcija
//ako e FALSE vraka response od ERROR objekt (ne niza, samo eden objekt)
async function EditAsync(args) {
  //najdi go StartupId i po nego povleci data
  let startupId = parseInt(args.stStartupID);
  if (isNaN(startupId)) startupId = 0;

  let responseStartup = null;
  if (startupId === 0) {
    responseStartup = await SmeService.New(args);
  } else {
    responseStartup = await SmeService.Edit(args);
  }

  //let responseStartup = await SmeService.Edit({ "stTypeID": args.stTypeID, "stItemGUID": args.stItemGUID });
  let responseLookupData = await LookupDataService.SearchByTypeIDs({
    LookupTypeIDs: args.LookupTypeIDs,
  });
  let responseCountriesScholarhips =
    await CountryService.GetScholarshipCountries();
  let responseCountriesProvinces =
    await CountryProvinceService.GetCountryProvincesAll();
  let responses = [
    responseStartup,
    responseLookupData,
    responseCountriesScholarhips,
    responseCountriesProvinces,
  ];
  return responseHelper.validateResponses(responses); //procitaj najgore kako raboti
}

async function CreateSmeFromStartupAsync(args) {
  let responseStartup = await SmeService.CreateSMEFromStartup(args);
  let responseLookupData = await LookupDataService.SearchByTypeIDs({
    LookupTypeIDs: args.LookupTypeIDs,
  });
  let responseCountriesScholarhips =
    await CountryService.GetScholarshipCountries();
  let responseCountriesProvinces =
    await CountryProvinceService.GetCountryProvincesAll();
  let responses = [
    responseStartup,
    responseLookupData,
    responseCountriesScholarhips,
    responseCountriesProvinces,
  ];
  return responseHelper.validateResponses(responses); //procitaj najgore kako raboti
}

async function DeleteAsync(args) {
  let response = await LookupDataService.Delete(args);
  let responses = [response];
  return responseHelper.validateResponses(responses); //procitaj najgore kako raboti
}

async function SearchAsync(args) {
  let response = await SmeService.Search(args);
  let responses = [response];
  return responseHelper.validateResponses(responses); //procitaj najgore kako raboti
}

async function SaveAsync(Record) {
  let responseEntity = await SmeService.Save(Record);
  let responses = [responseEntity];
  return responseHelper.validateResponses(responses);
}

const Reset = () => {
  return (dispatch) => {
    dispatch({ type: "SME_RESET" });
    //dispatch({ type: "GLOBAL_RESET"});    //GLOBALEN CACHE ZA HEADERS DALI DA SE POKAZUVAAT ILI NE
  };
};

const Edit = (args) => {
  return (dispatch) => {
    dispatch({ type: "SME_START" });

    EditAsync(args).then((responses) => {
      if (responses.error) {
        dispatch({ type: "SME_ERROR", error: responses.error_description });
      } else {
        dispatch({
          type: "SME_EDIT",
          Record: responses[0].data,
          LookupData: responses[1].data,
          ScholarshipCountries: responses[2].data, //vidi gore vo komentar za definicija na niza
          Provinces: responses[3].data,
        });

        dispatch({ type: "GLOBAL_REFRESH", Record: responses[0].data }); //GLOBALEN CACHE ZA HEADERS DALI DA SE POKAZUVAAT ILI NE
      }
    });
  };
};

// const Create = (args) => {

//     return dispatch => {
//         dispatch({ type: "SME_START" });

//         CreateAsync(args).then((responses) => {
//             if (responses.error) {
//                 dispatch({ type: "SME_ERROR", error: responses.error_description });
//             }
//             else {
//                 dispatch({
//                     // let responseLookupData = await ServiceLookupData.SearchByTypeIDs({"LookupTypeIDs" : args.LookupTypeIDs});
//                     // let responseCountriesScholarhips = await CountryService.GetScholarshipCountries();
//                     // let responseCountriesProvinces  = await CountryProvinceService.GetCountryProvincesAll();
//                     // let responses = [responseLookupData, responseCountriesScholarhips, responseCountriesProvinces];

//                     type: "SME_CREATE",
//                     LookupData : responses[0].data,
//                     ScholarshipCountries : responses[1].data, //vidi gore vo komentar za definicija na niza
//                     Provinces : responses[2].data
//                 });
//             }
//         });
//     }
// }

const Delete = (args) => {
  return (dispatch) => {
    dispatch({ type: "SME_START" });

    DeleteAsync(args).then((responses) => {
      if (responses.error) {
        dispatch({ type: "SME_ERROR", error: responses.error_description });
      } else {
        history.push("/lookupdata/find/" + args.ldTypeID);
      }
    });
  };
};

const Search = (args) => {
  return (dispatch) => {
    dispatch({ type: "SME_START" });

    SearchAsync(args).then((responses) => {
      if (responses.error) {
        dispatch({ type: "SME_ERROR", error: responses.error_description });
      } else {
        dispatch({
          type: "SME_SEARCH",
          Records: responses[0].data,
        });
      }
    });
  };
};

//OVOJ SEUSTE NE E NAPRAVEN DA RABOTI SO SERVICE
const Save = (Record) => {
  return (dispatch) => {
    dispatch({ type: "SME_START" }); //da se refreshira GUI-to so SPINNER-ot

    const keys = LanguageHelper.GetLanguageKeys();
    const isSubSuhara = AuthenticationHelper.IsSubSahara();

    let jsonInputData = [
      {
        element: "stName",
        type: "required",
        value: Record.stName,
        message: keys["NameCantBeEmpty"],
      },
      {
        element: "stCountryID",
        type: "SelectEmpty", //proverka na select isto kako vo MVC
        value: Record.stCountryID,
        message: keys["CountryCantBeEmpty"],
      },

      {
        element: "stProvinceID",
        type: "SelectEmpty", //proverka na select isto kako vo MVC
        value: Record.stProvinceID,
        message: keys["ProvinceCantBeEmpty"],
      },
      {
        element: "stAddress",
        type: "required",
        value: Record.stAddress,
        message: keys["AddressCantBeEmpty"],
      },
      {
        element: "stMobilePhone",
        type: "required",
        value: Record.stMobilePhone,
        message: keys["MobilePhoneCantBeEmpty"],
      },
      {
        element: "stSectorIDs",
        type: "required",
        value: Record.stSectorIDs,
        message: keys["SectorCantBeEmpty"],
      },
      {
        element: "stStartDate",
        type: "DateTimeEmpty", //proverka na select isto kako vo MVC
        value: Record.stStartDate,
        message: keys["StartDateEmpty"],
      },
      // {
      //     "element": "stInitFullEmployees",
      //     "type": "required",
      //     "value": Record.stInitFullEmployees,
      //     "message": keys["InitFullEmployeesEmpty"]
      // },
      // {
      //     "element": "stInitFullEmployees",
      //     "type": "Float",
      //     "value": Record.stInitFullEmployees,
      //     "message": keys["InitFullEmployeesNumber"]
      // },
      // {
      //     "element": "stInitPartEmployees",
      //     "type": "required",
      //     "value": Record.stInitPartEmployees,
      //     "message": keys["InitPartEmployeesEmpty"]
      // },
      // {
      //     "element": "stInitPartEmployees",
      //     "type": "Float",
      //     "value": Record.stInitPartEmployees,
      //     "message": keys["InitPartEmployeesNumber"]
      // },
      {
        element: "stBusinessOperationLocationID",
        type: "SelectEmpty",
        value: Record.stBusinessOperationLocationID,
        message: keys["BusinessOperationLocationEmpty"],
      },
      {
        element: "stBussinessFinancialIDs",
        type: "required",
        value: Record.stBussinessFinancialIDs,
        message: keys["BusinessFinancialEmpty"],
      },
      {
        element: "stNumberDailyClientID",
        type: "SelectEmpty",
        value: Record.stNumberDailyClientID,
        message: keys["NumberDailyClientEmpty"],
      },
      // {
      //     "element": "stFinancialYearClosingBusinessID",
      //     "type": "SelectEmpty",
      //     "value": Record.stFinancialYearClosingBusinessID,
      //     "message": keys["FinancialYearClosingBusinessEmpty"]
      // },
      {
        element: "stBusinessLoanID",
        type: "SelectEmpty",
        value: Record.stBusinessLoanID,
        message: keys["BusinessLoanEmpty"],
      },
      {
        element: "stBusinessInsuranceID",
        type: "SelectEmpty",
        value: Record.stBusinessInsuranceID,
        message: keys["BusinessInsuranceEmpty"],
      },
      {
        element: "stBusinessRevenueEnoughID",
        type: "SelectEmpty",
        value: Record.stBusinessRevenueEnoughID,
        message: keys["BusinessRevenueEnoughEmpty"],
      },
      {
        element: "stIncomeID",
        type: "SelectEmpty",
        value: Record.stIncomeID,
        message: keys["IncomeEmpty"],
      },
      {
        element: "stCurrentBusinessStatusID",
        type: "SelectEmpty",
        value: Record.stCurrentBusinessStatusID,
        message: keys["CurrentBusinessStatusEmpty"],
      },
      // {
      //     "element": "stProvinceOperationID",
      //     "type": "SelectEmpty",
      //     "value": Record.stProvinceOperationID,
      //     "message": keys["ProvincesOfBusinessOperationEmpty"]
      // },
      // {
      //     "element": "stNetProfit",
      //     "type": "Float",
      //     "value": Record.stNetProfit,
      //     "message": keys["NetProfitTextRequired"]
      // },
      // {
      //     "element": "stNetLoss",
      //     "type": "Float",
      //     "value": Record.stNetLoss,
      //     "message": keys["NetLossTextRequired"]
      // },
      {
        element: "stPassword",
        type: "password",
        value: Record.stPassword,
        message: keys["PasswordEmptyWith6Chars"],
      },
    ];
    //validacija
    let validationMessages = validatorHelper.validate(jsonInputData);

    //validacija
    //da se dodade
    if (validationMessages.length > 0) {
      logHelper.log("validationMessages");
      logHelper.log(validationMessages);

      dispatch({
        type: "SME_SAVE_ERROR",
        ValidationMessages: validationMessages,
        error: keys["FormCantBeSumitted"],
        Record: Record,
      }); //da ne prekucuva, toa sto e od client toa da mu vrati
    } else {
      SaveAsync(Record).then((responses) => {
        if (responses.error) {
          dispatch({
            type: "SME_SAVE_ERROR",
            error: responses.error_description, //od server gresakta
            Record: Record,
          }); //da ne prekucuva, toa sto e od client toa da mu vrati
        } else {
          //response[0] == Entity Record
          //response[1] == True ili Exception ako ne pomine uploaded
          dispatch({ type: "SME_SAVE_SUCCESS", Record: responses[0].data });
          dispatch({ type: "GLOBAL_REFRESH", Record: responses[0].data }); //GLOBALEN CACHE ZA HEADERS DALI DA SE POKAZUVAAT ILI NE
        }
      });
    }
  };
};

const SaveSubSahara = (Record) => {
  return (dispatch) => {
    dispatch({ type: "SME_START" }); //da se refreshira GUI-to so SPINNER-ot
    
    const keys = LanguageHelper.GetLanguageKeys();
    const isSubSuhara = AuthenticationHelper.IsSubSahara();

    let jsonInputData = [
      {
        element: "stName",
        type: "required",
        value: Record.stName,
        message: keys["NameCantBeEmpty"],
      },
      {
        element: "stCountryID",
        type: "SelectEmpty", //proverka na select isto kako vo MVC
        value: Record.stCountryID,
        message: keys["CountryCantBeEmpty"],
      },

      {
        element: "stProvinceID",
        type: "SelectEmpty", //proverka na select isto kako vo MVC
        value: Record.stProvinceID,
        message: keys["ProvinceCantBeEmpty"],
      },
      {
        element: "stAddress",
        type: "required",
        value: Record.stAddress,
        message: keys["AddressCantBeEmpty"],
      },
      {
        element: "stMobilePhone",
        type: "required",
        value: Record.stMobilePhone,
        message: keys["MobilePhoneCantBeEmpty"],
      },
      {
        element: "stSectorIDs",
        type: "required",
        value: Record.stSectorIDs,
        message: keys["SectorCantBeEmpty"],
      },
      // {
      //   element: "stStartDate",
      //   type: "DateTimeEmpty", //proverka na select isto kako vo MVC
      //   value: Record.stStartDate,
      //   message: keys["StartDateEmpty"],
      // },
      {
        element: "stInitFullEmployees",
        type: "required",
        value: Record.stInitFullEmployees,
        message: keys["InitFullEmployeesEmpty"],
      },
      {
        element: "stInitFullEmployees",
        type: "Float",
        value: Record.stInitFullEmployees,
        message: keys["InitFullEmployeesNumber"],
      },
      {
        element: "stCurrentNumberFullEmployees",
        type: "required",
        value: Record.stCurrentNumberFullEmployees,
        message: keys["CurrFullEmployees"],
      },
      {
        element: "stCurrentNumberFullEmployees",
        type: "Float",
        value: Record.stCurrentNumberFullEmployees,
        message: keys["CurrFullEmployees"],
      },
      {
        element: "stCurrentNumberPartEmployees",
        type: "required",
        value: Record.stCurrentNumberPartEmployees,
        message: keys["CurrPartEmployees"],
      },
      {
        element: "stCurrentNumberPartEmployees",
        type: "Float",
        value: Record.stCurrentNumberPartEmployees,
        message: keys["CurrPartEmployees"],
      },
      // {
      //     "element": "stInitPartEmployees",
      //     "type": "required",
      //     "value": Record.stInitPartEmployees,
      //     "message": keys["InitPartEmployeesEmpty"]
      // },
      // {
      //     "element": "stInitPartEmployees",
      //     "type": "Float",
      //     "value": Record.stInitPartEmployees,
      //     "message": keys["InitPartEmployeesNumber"]
      // },
      // {
      //     "element": "stFinancialYearClosingBusinessID",
      //     "type": "SelectEmpty",
      //     "value": Record.stFinancialYearClosingBusinessID,
      //     "message": keys["FinancialYearClosingBusinessEmpty"]
      // },
      // {
      //   element: "stBusinessLoanID",
      //   type: "SelectEmpty",
      //   value: Record.stBusinessLoanID,
      //   message: keys["BusinessLoanEmpty"],
      // },
      {
        element: "stCurrentBusinessStatusID",
        type: "SelectEmpty",
        value: Record.stCurrentBusinessStatusID,
        message: keys["CurrentBusinessStatusEmpty"],
      },
      // {
      //     "element": "stProvinceOperationID",
      //     "type": "SelectEmpty",
      //     "value": Record.stProvinceOperationID,
      //     "message": keys["ProvincesOfBusinessOperationEmpty"]
      // },
      {
        element: "stNetProfit",
        type: "Float",
        value: Record.stNetProfit,
        message: keys["NetProfitTextRequired"],
      },
      // {
      //     "element": "stNetLoss",
      //     "type": "Float",
      //     "value": Record.stNetLoss,
      //     "message": keys["NetLossTextRequired"]
      // },
      {
        element: "stPassword",
        type: "password",
        value: Record.stPassword,
        message: keys["PasswordEmptyWith6Chars"],
      },
      {
        element: "stSubSectorID",
        type: "SelectEmpty", //proverka na select isto kako vo MVC
        value: Record.stSubSectorID,
        message: keys["SubSectorCantBeEmpty"],
      },
      {
        element: "stBDAName",
        type: "required",
        value: Record.stBDAName,
        message: keys["BDANameCantBeEmpty"],
      },
      {
        element: "stCurrTurnover",
        type: "required",
        value: Record.stCurrTurnover,
        message: keys["CurrentTurnoverCantBeEmpty"],
      },
      {
        element: "stEstimatedTurnover",
        type: "required",
        value: Record.stEstimatedTurnover,
        message: keys["EstimatedProfitCantBeEmpty"],
      },
      {
        element: "stAttendedTrainingID",
        type: "SelectEmpty", //proverka na select isto kako vo MVC
        value: Record.stAttendedTrainingID,
        message: keys["AttendedTrainingCantBeEmpty"],
      },
      {
        element: "stBusinessKeepingRecordID",
        type: "SelectEmpty", //proverka na select isto kako vo MVC
        value: Record.stBusinessKeepingRecordID,
        message: keys["BusinessKeepingRecordCantBeEmpty"],
      },
      {
        element: "stNumSessionComplete",
        type: "required",
        value: Record.stNumSessionComplete,
        message: keys["NumSessionCompleteCantBeEmpty"],
      },
      {
        element: "stNumSessionGrow",
        type: "required",
        value: Record.stNumSessionGrow,
        message: keys["NumSessionGrowCantBeEmpty"],
      },
      {
        element: "stBusinessPlanStatusID",
        type: "SelectEmpty", //proverka na select isto kako vo MVC
        value: Record.stBusinessPlanStatusID,
        message: keys["BusinessPlanStatusCantBeEmpty"],
      },
      {
        element: "stLoanStatusID",
        type: "SelectEmpty", //proverka na select isto kako vo MVC
        value: Record.stLoanStatusID,
        message: keys["LoanStatusCantBeEmpty"],
      },
      {
        element: "stAmountApllied",
        type: "required",
        value: Record.stAmountApllied,
        message: keys["AmountAplliedCantBeEmpty"],
      },
      {
        element: "stAmountApllied",
        type: "Float",
        value: Record.stAmountApllied,
        message: keys["AmountAplliedNumber"],
      },
      {
        element: "stAmountAccessed",
        type: "required",
        value: Record.stAmountAccessed,
        message: keys["AmountAccessedCantBeEmpty"],
      },
      {
        element: "stAmountAccessed",
        type: "Float",
        value: Record.stAmountAccessed,
        message: keys["AmountAccessedNumber"],
      },
    ];
    //validacija
    let validationMessages = validatorHelper.validate(jsonInputData);

    //validacija
    //da se dodade
    if (validationMessages.length > 0) {
      logHelper.log("validationMessages");
      logHelper.log(validationMessages);

      dispatch({
        type: "SME_SAVE_ERROR",
        ValidationMessages: validationMessages,
        error: keys["FormCantBeSumitted"],
        Record: Record,
      }); //da ne prekucuva, toa sto e od client toa da mu vrati
    } else {
      SaveAsync(Record).then((responses) => {
        if (responses.error) {
          dispatch({
            type: "SME_SAVE_ERROR",
            error: responses.error_description, //od server gresakta
            Record: Record,
          }); //da ne prekucuva, toa sto e od client toa da mu vrati
        } else {
          //response[0] == Entity Record
          //response[1] == True ili Exception ako ne pomine uploaded
          dispatch({ type: "SME_SAVE_SUCCESS", Record: responses[0].data });
          dispatch({ type: "GLOBAL_REFRESH", Record: responses[0].data }); //GLOBALEN CACHE ZA HEADERS DALI DA SE POKAZUVAAT ILI NE
        }
      });
    }
  };
};

const CreateSmeFromStartup = (args) => {
  return (dispatch) => {
    dispatch({ type: "SME_START" });

    CreateSmeFromStartupAsync(args).then((responses) => {
      if (responses.error) {
        dispatch({ type: "SME_ERROR", error: responses.error_description });
      } else {
        dispatch({
          type: "SME_EDIT",
          Record: responses[0].data,
          LookupData: responses[1].data,
          ScholarshipCountries: responses[2].data, //vidi gore vo komentar za definicija na niza
          Provinces: responses[3].data,
        });
        dispatch({ type: "GLOBAL_REFRESH", Record: responses[0].data }); //GLOBALEN CACHE ZA HEADERS DALI DA SE POKAZUVAAT ILI NE
      }
    });
  };
};

export default {
  Save,
  SaveSubSahara,
  Edit,
  Search,
  Delete,
  Reset,
  CreateSmeFromStartup,
};
